/**
 * Function: fetchWeatherFromAPI
 * @description Fetches weather data from the WeatherAPI service for a given address.
 * @param {string} address - The location address to fetch weather for.
 * @returns {Promise<Object>} The weather data from the API.
 * @throws {Error} If there's an error fetching the weather data.
 */
export const fetchWeatherFromAPI = async (address) => {
  if (!address) {
    throw new Error('Address is required to fetch weather data');
  }

  try {
    const API_KEY = process.env.REACT_APP_WEATHERAPI_KEY;
    const encodedAddress = encodeURIComponent(address);
    const response = await fetch(
      `https://api.weatherapi.com/v1/forecast.json?key=${API_KEY}&q=${encodedAddress}&days=7&aqi=no`
    );

    if (!response.ok) {
      throw new Error(`Weather API responded with status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error(`Error fetching weather data: ${error.message}`);
  }
};
